/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionResponse extends models.AppSecopsSbomVersion {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionResponse>): AppSecopsSbomVersionResponse {
        let obj = Object.assign(new AppSecopsSbomVersionResponse(), model);
        AppSecopsSbomVersionResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionResponse>): AppSecopsSbomVersionResponse {
        if (!model) return null;
        return AppSecopsSbomVersionResponse.newInstance(<AppSecopsSbomVersionResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionResponse) {
        if (!obj) return;

        models.AppSecopsSbomVersionResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionResponse): boolean {
        if (models.AppSecopsSbomVersion.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomVersionResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of vulnerability IDs detected in the components of this SBOM version
     */
    vulnerability_ids: Array<string>;

    /**
     * List of IDs that associate each vulnerability with this SBOM version, including version-specific details
     */
    sbom_version_vulnerability_ids: Array<string>;

}
